import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Croc from '@/components/Croc'
import Programas from '@/components/Programas'
import Informe from '@/components/Informe'
import Videos from '@/components/Videos'
import NoticiasPage from '@/components/NoticiasPage'
import Noticias from '@/components/Noticias'
import Vacantes from '@/components/Vacantes'
import VacantesFullPage from '@/components/VacantesFullPage'
import Contacto from '@/components/Contacto'
import Error404 from '@/components/errors/Error404'
import Convenios from '@/components/Convenios'
import Conocenos from '@/components/Conocenos'
Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {

      path: '/',
      component: Home,
      name:'Home',
    },
    {
      path: '/hisoria-croc',
      component: Croc,
      name:'Croc',
    },
    {
      path: '/programas-sociales',
      component: Programas,
      name:'Programas',
    },
    {
      path: '/informe-croc',
      component: Informe,
      name:'Informe',
    },
    {
      path: '/videos',
      component: Videos,
      name:'Videos'
    },
    {
      path: '/noticias',
      component: Noticias,
      name:'Noticias',
    },
    {
      path: '/noticias/:slug',
      name:'NoticiasPage',
      component: NoticiasPage,
    },
    {
      path: '/vacantes',
      component: Vacantes,
      name:'Vacantes',
    },
    {
      path: '/fullpage',
      component: VacantesFullPage,
      name:'VacantesFullPage',
    },
    {
      path: '/contacto',
      component: Contacto,
      'name':'Contacto',
    },
    {
      path: '/convenios-croc',
      component: Convenios,
      'name':'Convenios',
    },
    {
      path: '/conocenos',
      component: Conocenos,
      'name':'Conocenos',
    },
    { path: "*", component: Error404}
  ],
  linkActiveClass: 'is-active'

})



// WEBPACK FOOTER //
// ./src/router/index.js